import React from 'react';
import { Typography } from 'antd';
import { Link } from 'react-router-dom';
import Spinner from '../../spinner';
import type { OrderHistoryProductCardProps } from '../../interfaces';
import { formatSizeLabel } from '../../../utils/sizeOptions';

import './OrderHistoryProductCard.scss';

const { Text } = Typography;

const OrderHistoryProductCard: React.FC<OrderHistoryProductCardProps> = ({
  item,
  imageUrl,
  price,
  isLoading,
  errorMessage,
}) => {
  return (
    <Link to={`/products/${item.product.id}`} className="product-card" aria-label={`Open ${item.product.title}`}>
      {isLoading ? (
        <div className="product-image-loading">
          <Spinner />
        </div>
      ) : (
        <img
          src={imageUrl}
          alt={item.product.title}
          className="product-image"
        />
      )}
      <div className="product-details">
        <h4>{item.product.title}</h4>
        {item.size && <p>Size: {formatSizeLabel(item.size)}</p>}
        <p>Material: {item.material}</p>
        <p>Quantity: {item.quantity}</p>
        <p>Price: ${price ?? '—'}</p>
        {errorMessage && (
          <Text type="danger" className="product-card-error">
            {errorMessage}
          </Text>
        )}
      </div>
    </Link>
  );
};

export default React.memo(OrderHistoryProductCard);
